import i18n, { projectLanguageToLng } from "./index";

const statusKeys = {
  "Analyzing user message": "status.analyzingMessage",
  "Reading your documents": "status.readingDocuments",
  "Searching vault": "status.searchingVault",
  "Searching the web": "status.searchingWeb",
  "Updating case brief": "status.updatingBrief",
  "Crafting response": "status.craftingResponse"
} as const;

export function translateCaseBriefStatus(status: string, language: string | null): string {
  const key = statusKeys[status as keyof typeof statusKeys];
  return key ? i18n.getFixedT(projectLanguageToLng(language), "createProject")(key) : status;
}
